<template>
    <div class="Information">
        <div class="row">
            <div class="col col-md-4">
                <div class="record-section">
                    <h4>Enrollment Information:</h4>
                    <p>
                        <span class="bold">Program Name: </span> {{ ChildRecordData.ClientProgramMembership.SubProgramName }}

                    </p>
                    <p>
                        <span class="bold">Start Date: </span>
                        <DateEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.StartDate"
                                    v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                    v-bind:edit-mode="EditMode"
                                    data-label="Start Date"
                                    property-name="StartDate"
                                    update-method="Foster/FosterClients/UpdateStartDate"
                                    required="true"
                                    warning-notice="Modifying the start date (original placement date) may affect other records, such as initial home placement dates, initial case manager assignment dates, etc...  You have been warned."
                                    :global-update="true" />
                    </p>
                    <p>
                        <span class="bold">Termination Info: </span>
                        <DischargeEditor v-bind:old-end-date="ChildRecordData.ClientProgramMembership.EndDate"
                                         v-bind:old-reason="ChildRecordData.ClientProgramMembership.DischargeReason"
                                         v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                         record-id-name="ClientSubProgramMembershipID"
                                         v-bind:edit-mode="EditMode"
                                         data-label="Termination Info"
                                         discharge-method="Foster/Membership_FosterResourceFamily_ClientSubProgramMembership/TerminateSubProgramMembership"
                                         revert-method="Foster/Membership_FosterResourceFamily_ClientSubProgramMembership/RevertSubProgramTermination"
                                         v-bind:options="GetSubProgramTerminationReasons"
                                         discharge-language="Terminate" />
                    </p>
                    <p>
                        <span class="bold">Days in Program: </span><span>{{ ChildRecordData.ClientProgramMembership.DaysInSubProgram }}</span>
                    </p>
                    <p>
                        <span class="bold">Adopted by: </span>
                        <SelectEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.AdoptedByFosterFamilyFamily != null ? ChildRecordData.ClientProgramMembership.AdoptedByFosterFamilyFamily.Id : null"
                                      v-bind:old-value-text="ChildRecordData.ClientProgramMembership.AdoptedByFosterFamilyFamily != null ? ChildRecordData.ClientProgramMembership.AdoptedByFosterFamilyFamily.Name : null"
                                      v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                      v-bind:edit-mode="EditMode"
                                      data-label="Adopted by (List below from Families List Pane.  Adjust List Filters if family doesn't show.')"
                                      property-name="AdoptedByFosterFamilyFamilyID"
                                      update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                      v-bind:options="OptionsFosterFamilies" />
                    </p>
                    <p>
                        <span class="bold">Adopted on: </span>
                        <DateEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.AdoptedByFosterFamilyDate"
                                    v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                    v-bind:edit-mode="EditMode"
                                    data-label="Date of Adoption by Olive Crest Family"
                                    property-name="AdoptedByFosterFamilyDate"
                                    update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                    :global-update="true" />
                    </p>
                </div>
                
            </div>
            <div class="col col-md-4">
                <div class="record-section">
                    <h4>Running Summary:</h4>
                    <TextAreaEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.RunningSummary"
                                    v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                    v-bind:edit-mode="EditMode"
                                    data-label="Running Summary"
                                    property-name="RunningSummary"
                                    update-method="Foster/FosterClients/UpdateRunningSummary"
                                    required="false"
                                    :global-update="true" />
                </div>
                
            </div>
            <div class="col col-md-4">
                <div class="record-section">
                    <h4>Important Dates:</h4>
                    <p>
                        <span class="bold">Last Court Date: </span>
                        <StringEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.LastCourtDate"
                                      v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                      v-bind:edit-mode="EditMode"
                                      data-label="Last Court Date"
                                      property-name="RunningSummary"
                                      update-method="Foster/FosterClients/UpdateLastCourtDate"
                                      v-bind:required="true" />
                    </p>
                    <p>
                        <span class="bold">Next Court Date: </span>
                        <StringEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.NextCourtDate"
                                      v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                      v-bind:edit-mode="EditMode"
                                      data-label="Next Court Date"
                                      property-name="RunningSummary"
                                      update-method="Foster/FosterClients/UpdateNextCourtDate"
                                      v-bind:required="true" />
                    </p>
                    <p>
                        <span class="bold">Last Ansel Casey: </span>
                        <DateEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.LastAnselCasey"
                                    v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                    v-bind:edit-mode="EditMode"
                                    data-label="Last Ansel Casey"
                                    property-name="LastAnselCasey"
                                    update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                    :global-update="true" />
                    </p>
                    <p>
                        <span class="bold">Last CAFAS: </span>
                        <DateEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.LastCAFAS"
                                    v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                    v-bind:edit-mode="EditMode"
                                    data-label="Last CAFAS"
                                    property-name="LastCAFAS"
                                    update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                    :global-update="true" />
                    </p>
                    <p>
                        <span class="bold">Last CPAForm: </span>
                        <DateEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.LastCPAForm"
                                    v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                    v-bind:edit-mode="EditMode"
                                    data-label="Last CPAForm"
                                    property-name="LastCPAForm"
                                    update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                    :global-update="true" />
                    </p>
                    <p v-if="IsPNW">
                        <span class="bold">DCYF Original Placement Date (OPD): </span>
                        <DateEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.OriginalPlacementDate"
                                    v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                    v-bind:edit-mode="EditMode"
                                    data-label="DCYF Original Placement Date (OPD)"
                                    property-name="OriginalPlacementDate"
                                    update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                    :global-update="true" />
                    </p>
                    <p v-if="IsPNW">
                        <span class="bold">Last Supervision Plan: </span>
                        <DateEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.LastSuperPlan"
                                    v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                    v-bind:edit-mode="EditMode"
                                    data-label="Last Supervision Plan"
                                    property-name="LastSuperPlan"
                                    update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                    :global-update="true" />
                    </p>
                    <p v-if="IsPNW">
                        <span class="bold">Initial Caregiver Contact Date: </span>
                        <DateEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.InitialCaregivercontactDate"
                                    v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                    v-bind:edit-mode="EditMode"
                                    data-label="Initial Caregiver Contact Date"
                                    property-name="InitialCaregiverContactDate"
                                    update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                    :global-update="true" />
                    </p>
                    <p v-if="IsPNW">
                        <span class="bold">Initial Social Worker Contact Date: </span>
                        <DateEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.InitialSocialWorkerContactDate"
                                    v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                    v-bind:edit-mode="EditMode"
                                    data-label="Initial Social Worker Contact Date"
                                    property-name="InitialSocialWorkercContactDate"
                                    update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                    :global-update="true" />
                    </p>
                </div>
                
            </div>
            <div class="col col-md-4">
                <div class="record-section">
                    <h4>Additional Information:</h4>
                    <p v-if="IsPNW">
                        <span class="bold">Region: </span>
                        <SelectEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.Region"
                                      v-bind:old-value-text="ChildRecordData.ClientProgramMembership.Region"
                                      v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                      v-bind:edit-mode="EditMode"
                                      data-label="Region"
                                      property-name="Region"
                                      update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                      v-bind:options="[{text:'',value:null},{text:'1',value:'1'},{text:'2',value:'2'},{text:'3',value:'3'},{text:'4',value:'4'},{text:'5',value:'5'},{text:'6',value:'6'}]" />
                    </p>
                    <p v-if="IsPNW">
                        <span class="bold">DCYF Field Office: </span>
                        <SelectEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.FieldOffice"
                                      v-bind:old-value-text="ChildRecordData.ClientProgramMembership.FieldOffice"
                                      v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                      v-bind:edit-mode="EditMode"
                                      data-label="Field Office"
                                      property-name="FieldOffice"
                                      update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                      v-bind:options="PNWFieldOffices" />
                    </p>
                    <p>
                        <span class="bold">Primary Language Spoken: </span>
                        <SelectEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.PrimaryLanguageSpoken"
                                      v-bind:old-value-text="ChildRecordData.ClientProgramMembership.PrimaryLanguageSpoken"
                                      v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                      v-bind:edit-mode="EditMode"
                                      data-label="Primary Language Spoken"
                                      property-name="PrimaryLanguageSpoken"
                                      update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                      v-bind:options="PrimaryLanguageSpokenOptions" />
                    </p>
                    <p>
                        <span class="bold">Prior Placements Amount: </span>
                        <IntegerEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.PriorPlacementCount"
                                       v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                       v-bind:edit-mode="EditMode"
                                       data-label="Prior Placements Amount"
                                       property-name="PriorPlacementCount"
                                       update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                       :global-update="true" />
                    </p>
                    <p>
                        <span class="bold">Court Plan: </span>
                        <TextAreaEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.CourtPlan"
                                        v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                        v-bind:edit-mode="EditMode"
                                        data-label="Court Plan"
                                        property-name="CourtPlan"
                                        update-method="Foster/FosterClients/UpdateCourtPlan"
                                        :global-update="true" />
                    </p>
                    <p>
                        <span class="bold">Dependency Status: </span>
                        <TextAreaEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.DependencyStatus"
                                        v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                        v-bind:edit-mode="EditMode"
                                        data-label="Dependency Status"
                                        property-name="DependencyStatus"
                                        update-method="Foster/FosterClients/UpdateDependencyStatus"
                                        :global-update="true" />
                    </p>
                    <p>
                        <span class="bold">Placement Type: </span>
                        <SelectEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.PlacementType"
                                      v-bind:old-value-text="ChildRecordData.ClientProgramMembership.PlacementType"
                                      v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                      v-bind:edit-mode="EditMode"
                                      data-label="Placement Type"
                                      property-name="PlacementType"
                                      update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                      v-bind:options="OptionsPlacementType" />
                    </p>
                    <p>
                        <span class="bold">Placing Agency: </span>
                        <SelectEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.PlacementAgency.AgencyTypeID"
                                      v-bind:old-value-text="ChildRecordData.ClientProgramMembership.PlacementAgency.Name"
                                      v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                      v-bind:edit-mode="EditMode"
                                      data-label="Placing Agency"
                                      property-name="AgencyID"
                                      update-method="Foster/FosterClients/UpdateAgency"
                                      v-bind:options="Agencies" />
                    </p>
                    <p>
                        <span class="bold">Case Name: </span>
                        <StringEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.CaseName"
                                      v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                      v-bind:edit-mode="EditMode"
                                      data-label="Case Name"
                                      property-name="CaseName"
                                      update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                      v-bind:required="false" />
                    </p>
                    <p>
                        <span class="bold">Kept-In-Community: </span>
                        <SelectEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.KeptInCommunity == true ? 'Yes' : ChildRecordData.ClientProgramMembership.KeptInCommunity == null ? '' : 'No'"
                                      v-bind:old-value-text="ChildRecordData.ClientProgramMembership.KeptInCommunity == true ? 'Yes' : ChildRecordData.ClientProgramMembership.KeptInCommunity == null ? '' :'No'"
                                      v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                      v-bind:edit-mode="EditMode"
                                      data-label="Kept-In-Community"
                                      property-name="KeptInCommunity"
                                      update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                      v-bind:options="TrueFalseOptions" />
                    </p>
                </div>
                
            </div>
        </div>
        <div class="row">
            <div class="col col-md-6">
                <div class="record-section">
                    <h4>Service Enrollment:</h4>

                    <ProgramServiceAssignmentEditor :edit-mode="EditMode"
                                                    :sub-program-id="ChildRecordData.ClientProgramMembership.SubProgramID"
                                                    rate-supplement-label="Monthly Rate to Family"
                                                    custom-rate-label="Monthly Rate Total Amount"
                                                    :chart-id="ChildRecordData.ClientProgramMembership.Id"
                                                    :field-data="ChildRecordData.ClientProgramMembership.ProgramServices"
                                                    :require-previous-end-date="IsCaregiverSupport" />
                    <p class="bold">Client Under Audit (grants access to external auditor acct): </p>
                    <SelectEditor v-bind:old-value="ChildRecordData.ClientProgramMembership.IsUnderAudit == true ? 'Yes' : ChildRecordData.ClientProgramMembership.IsUnderAudit == null ? 'No' : 'No'"
                                  v-bind:old-value-text="ChildRecordData.ClientProgramMembership.IsUnderAudit == true ? 'Yes' : ChildRecordData.ClientProgramMembership.IsUnderAudit == null ? 'No' :'No'"
                                  v-bind:record-id="ChildRecordData.ClientProgramMembership.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Client is Under Audit"
                                  property-name="IsUnderAudit"
                                  update-method="Foster/FosterClients/UpdateClientSubProgramMembership"
                                  v-bind:options="TrueFalseOptions" />
                </div>
                
            </div>
            <div class="col col-md-6" v-if="IsCaregiverSupport">
                <div class="record-section">
                    <h4>Program Status:</h4>
                    <SingleMembershipEditorRequest :fields="[{name: 'Name', title: 'STATUS'}, {name: 'StartDate', title: 'STARTED', callback: 'formatDate|MM/DD/YY'}, {name: 'EndDate', title: 'ENDED', callback: 'formatDate|MM/DD/YY|N/A'}]"
                                                   :field-data="ChildRecordData.ClientProgramMembership.ClientPhases"
                                                   :chart-id="ChildRecordData.Id"
                                                   :edit-mode="EditMode && CheckPermission('Foster.Phase.Edit')"
                                                   select-label="Status:"
                                                   options-type="Data"
                                                   :options-method="[{text:'Initial Engagement',value:'Initial Engagement'},{text:'Ongoing Engagement',value:'Ongoing Engagement'},{text:'Active',value:'Active'}]"
                                                   :options-method-record-id="ChildRecordData.Id"
                                                   add-record-method="Foster/Phase/AddFirstPhase"
                                                   add-record-record-property-name="Name"
                                                   :add-record-additional-payload="{ClientSubProgramMembershipID: ChildRecordData.Id}"
                                                   add-record-modal-title="Initial Status"
                                                   transfer-record-method="Foster/Phase/TransferPhase"
                                                   transfer-record-record-property-name="Name"
                                                   :transfer-record-additional-payload="{ClientSubProgramMembershipID: ChildRecordData.Id}"
                                                   transfer-record-modal-title="Transfer to New Status"
                                                   transfer-record-effective-date-property-name="EffectiveDate"
                                                   :require-previous-end-date="true"
                                                   transfer-record-previous-end-date-property-name="PreviousEndDate"
                                                   delete-record-method="Foster/Phase/DeletePhase"
                                                   :delete-record-additional-payload="{Id: ChildRecordData.Id}"
                                                   delete-record-modal-title="Delete Current Status"
                                                   delete-record-modal-text="NOTICE: You are about to delete this child's current Status.  If there was a previous Status assigned, it will be re-activated." />
                </div>
            </div>
        </div>
        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" />
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import DateEditor from '../../../Core/ItemEditors/DateEditor.vue';
    import StringEditor from '../../../Core/ItemEditors/StringEditor.vue';
    import IntegerEditor from '../../../Core/ItemEditors/IntegerEditor.vue';
    import SelectEditor from '../../../Core/ItemEditors/SelectEditor.vue';
    import TextAreaEditor from '../../../Core/ItemEditors/TextAreaEditor.vue';
    import DischargeEditor from '../../../Core/ItemEditors/DischargeEditor.vue';
    import SingleMembershipEditor from '../../../Core/ItemEditors/SingleMembershipEditor.vue';
    import ProgramServiceAssignmentEditor from '../../../Core/ItemEditors/ProgramServiceAssignmentEditor.vue';
    import SingleMembershipEditorRequest from '../../../Core/ItemEditors/SingleMembershipEditorRequest.vue';
    import EditMode from '../../../Core/ItemEditors/EditMode.vue';
    export default {
        props: [
            'ChildRecordData'
        ],
        data: function () {
            return {
                Agencies: [],
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            },
            GetAgencies() {
                this.$MasterAPI.ExecuteRequest("GET", "Foster/FosterClients/GetAgencies", {}, this.GetAgenciesSuccess, () => { }, false);
            },
            GetAgenciesSuccess(response) {
                this.Agencies = response.data.data;
                for (var i = 0; i < this.Agencies.length; i++) {
                    this.Agencies[i].text = this.Agencies[i].Name;
                    this.Agencies[i].value = this.Agencies[i].Id;
                }
            }
        },
        components: {
            DateEditor,
            StringEditor,
            DischargeEditor,
            SingleMembershipEditor,
            TextAreaEditor,
            IntegerEditor,
            SelectEditor,
            ProgramServiceAssignmentEditor,
            SingleMembershipEditorRequest,
            EditMode
        },
        mounted() {
            this.GetAgencies();
        },
        computed: {
            GetSubProgramTerminationReasons: function () {
                let subprogram = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgram"](this.ChildRecordData.ClientProgramMembership.SubProgramID);
                let returnObj = [];
                if (subprogram.DischargeReasons.length > 0) {
                    subprogram.DischargeReasons.forEach(function (item) {
                        returnObj.push({ text: item.Label, value: item.Id, grouping: item.Grouping });
                    })
                }
                return returnObj;
            },
            OptionsPlacementType: function () {
                if (this.IsCaregiverSupport) {
                    return [
                        {
                            "text": "Foster",
                            "value": "Foster"
                        },
                        {
                            "text": "Kinship",
                            "value": "Kinship"
                        }
                    ]
                } else {
                    return this.$store.state.Options.PlacementType;
                }
                
            },
            OptionsFosterFamilies: function () {
                let options = [{text:"",value:""}];
                let familyEnrollments = this.$store.state.Families.FamilyEnrollmentsList;
                familyEnrollments.forEach(function (item) {
                    options.push({
                        text: item.Family.Name,
                        value: item.Family.Id,
                    });
                });
                return options;
            },
            PrimaryLanguageSpokenOptions: function () {
                return this.$store.state.Options.PrimaryLanguageSpoken;
            },
            PNWFieldOffices: function () {
                return this.$store.state.Options.PNWFosterFieldOffices;
            },
            IsPNW: function () {
                if (this.$store.state.Options.PNWSubPrograms.includes(this.ChildRecordData.ClientProgramMembership.SubProgramID.toUpperCase())) {
                    return true;
                } else {
                    return false;
                }
            },
            IsCaregiverSupport: function () {
                let caregiverSupportSubProgramIDs = ['D9B74D70-B9B0-411C-BC1B-90B608036062',
                    'EACF40B6-EF88-41D0-BE4B-6D4F64950865',
                    '33E864F6-20F5-46A2-B586-1FD174DEFBFA',
                    '130F6819-F937-41A7-8FC0-29E052E1F6CC',
                    '12943A82-3156-4270-91A3-63200C6C4AE9',
                    '3F28D8CE-4CD8-4CC4-9984-9AE0BD645DA0'].map(id => id.toUpperCase());

                let subProgramID = this.ChildRecordData
                    && this.ChildRecordData.ClientProgramMembership
                    && this.ChildRecordData.ClientProgramMembership.SubProgramID;

                return !!subProgramID && caregiverSupportSubProgramIDs.includes(subProgramID.toUpperCase());
            },
            TrueFalseOptions: function () {
                return this.$store.state.Options.TrueFalseOptions;
            }
        }
    }
</script>

<style scoped>
</style>